import { createMuiTheme } from "@material-ui/core";

export const MainTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#00AEEF",
    },
  },
});



// WEBPACK FOOTER //
// ./src/theme/MainTheme.ts